// extracted by mini-css-extract-plugin
export var askAiIcon = "_nq-j";
export var category = "_nq-9";
export var categoryHeader = "_nq-e";
export var container = "_nq-0";
export var group = "_nq-a";
export var groupItems = "_nq-f";
export var groupSeparator = "_nq-k";
export var loading = "_nq-1";
export var noResults = "_nq-3";
export var placeholder = "_nq-2";
export var resultContent = "_nq-5";
export var resultIcon = "_nq-c";
export var resultItem = "_nq-g";
export var resultMeta = "_nq-8";
export var resultSubtitle = "_nq-7";
export var resultSuffix = "_nq-i";
export var resultTitle = "_nq-6";
export var resultsList = "_nq-4";
export var searchGroup = "_nq-d";
export var selected = "_nq-h";
export var subgroup = "_nq-b";